module.exports = __webpack_public_path__ + "static/media/lightbulb--big.43bd2598.png";